<template>
  <v-list-item
    :to="item.href ? undefined : to"
    :href="item.href || undefined"
    :target="item.href ? '_blank' : undefined"
    :rel="item.href ? 'noopener noreferrer' : undefined"
    exact
    active-class=""
    exact-active-class=""
    :class="itemClasses"
    class="app-navigation-drawer__item"
    @click="onClick"
  >
    <v-list-item-icon class="app-navigation-drawer__item-icon">
      <v-icon small>{{ item.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content v-if="!mini">
      <v-list-item-title class="body-2 app-navigation-drawer__item-title">
        {{ item.text }}
        <span v-if="item.subtitle" class="font-weight-light">{{ item.subtitle }}</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'NavigationDrawerNavItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [String, Object],
      default: undefined,
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'section', 'footer'].includes(value),
    },
  },

  computed: {
    itemClasses() {
      return {
        'app-navigation-drawer__item--active': this.active,
        'app-navigation-drawer__item--section': this.variant === 'section',
        'app-navigation-drawer__item--mini': this.mini,
        'rounded-lg':
          !this.mini && (this.variant === 'primary' || this.variant === 'footer'),
        'mb-1': !this.mini && this.variant === 'primary',
        rounded: this.variant === 'section',
      };
    },
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
.app-navigation-drawer__item {
  min-height: 40px;
  color: rgba(255, 255, 255, 0.9);
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.app-navigation-drawer__item--section {
  /* 1px less to align icons with primary nav past section card border */
  padding-left: 7px !important;
}

.app-navigation-drawer__item-icon {
  margin: 0 12px 0 0 !important;
  min-width: 24px;
  align-self: center;
}

.app-navigation-drawer__item--mini {
  padding-left: 0 !important;
  padding-right: 0 !important;
  min-height: 48px;
  justify-content: center !important;
}

.app-navigation-drawer__item--mini .app-navigation-drawer__item-icon {
  margin: 0 !important;
  min-width: auto;
}

.app-navigation-drawer__item >>> .v-list-item__content {
  color: rgba(255, 255, 255, 0.9) !important;
}

.app-navigation-drawer__item >>> .v-list-item__title,
.app-navigation-drawer__item-title {
  color: rgba(255, 255, 255, 0.9) !important;
}

.app-navigation-drawer__item >>> .v-list-item__title span {
  color: rgba(255, 255, 255, 0.65) !important;
}

.app-navigation-drawer__item >>> .v-icon {
  color: rgba(255, 255, 255, 0.9) !important;
}

.app-navigation-drawer__item--active {
  background: rgba(255, 20, 99, 0.18) !important;
}

.app-navigation-drawer__item--active >>> .v-list-item__title,
.app-navigation-drawer__item--active >>> .v-list-item__title span,
.app-navigation-drawer__item--active >>> .v-icon {
  color: #ff1463 !important;
}
</style>
